var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82.15mm",
    height: "82.15mm",
    viewBox: "0 0 82.15 82.15",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54.067 -99.405)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(45)",
    cx: 166.61,
    cy: 44.642,
    r: 29.196,
    fill: "none",
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(45)",
    cx: 166.61,
    cy: 19.475,
    r: 29.196,
    fill: "none",
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(45)",
    cx: 156.37,
    cy: 32.058,
    r: 3.9927,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf4ded225c8c625e9af328e35634aa1c.svg";
export { ForwardRef as ReactComponent };